<template>
  <!--
    Used to edit the Resorts 
  -->
  <div class="resortDetails">
    <LoadingPlaceholder v-if="loading" />
    <template v-else>
      <template v-if="resort">
        <h4>{{ $t("resortForm.basicInfo") }}</h4>
        <div class="ml-4 mt-4">
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">{{ $t("id") }}</label>
            <div class="col-12 col-md-3">
              <span>{{ resort.id }}</span>
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">{{ $t("key") }}</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.resortKey"
                v-focus
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">{{ $t("Short Name") }}</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.attributes.short_name"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Timezone</label>
            <div class="col-12 col-md-3">
              <select
                v-model="resort.timeZoneId"
                :class="['form-control m-input m-input--air']"
              >
                <option
                  v-for="(tz, index) in timezones"
                  :key="`tz-spot-${index}`"
                  :value="tz"
                >
                  {{ `${tz}` }}
                </option>
              </select>
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Latitude</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.location.latitude"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Longitude</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.location.longitude"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Altitude</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.location.altitude"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Country Code</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.countryCode"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Provinces</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resortProvinces"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">H ISO</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.attributes.h_iso"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">H MAX</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.attributes.h_max"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">H MIN</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.attributes.h_min"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Weather Url</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.attributes.weather_url"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Company Name</label>
            <div class="col-12 col-md-3">
              <input
                v-model="resort.attributes.company_name"
                class="form-control m-input m-input--air"
                type="text"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <LoadingPlaceholder v-if="flowLoading" />
          <div
            v-else
            class="form-group row mb-4"
          >
            <label class="col-12 col-md-2 mt-2">Flow</label>
            <div class="col-12 col-md-3">
              <select
                v-model="flow.clazz"
                :class="['form-control m-input m-input--air']"
              >
                <option
                  v-for="(flw, index) in flows"
                  :key="`flw-spot-${index}`"
                  :value="flw.id"
                >
                  {{ `${flw.value}` }}
                </option>
              </select>
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Visible</label>
            <div class="col-12 col-md-1">
              <input
                v-model="resort.visible"
                class="form-control m-input mt-2"
                type="checkbox"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Active</label>
            <div class="col-12 col-md-1">
              <input
                v-model="resort.active"
                class="form-control m-input mt-2"
                type="checkbox"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Composite</label>
            <div class="col-12 col-md-1">
              <input
                v-model="resort.composite"
                class="form-control m-input mt-2"
                type="checkbox"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
          <div class="form-group row mb-4">
            <label class="col-12 col-md-2 mt-2">Has Skiline Chart</label>
            <div class="col-12 col-md-1">
              <input
                v-model="resort.hasSkilineChart"
                class="form-control m-input mt-2"
                type="checkbox"
              />
            </div>
            <div class="col-12 col-md-7" />
          </div>
        </div>
        <button
          v-if="!authenticationHasRole('zerolevel')"
          class="btn btn-sm btn-primary mt-4 float-right"
          :disabled="!hasFlow"
          @click="updateResort"
        >
          <font-awesome-icon
            class="mr-2"
            icon="upload"
          />{{ $t("save") }}
        </button>
        <div class="clearfix" />

        <DatabaseAuditLogList
          ref="databaseAuditLogList"
          :resort-crud-id="resort.id"
          @reload="getResort"
        />
      </template>
      <template v-else>
        {{ $t("noDataAvailable") }}
      </template>
    </template>
  </div>
</template>

<script>
import { errorMixin } from "@/mixins/errorMixin.js";
import { authenticationMixin } from "@/mixins/authenticationMixin";
import { dateTimeMixin } from "@/mixins/dateTimeMixin.js";

export default {
  name: "ResortDetails",
  components: {
    DatabaseAuditLogList: () =>
      import("@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue"),
  },
  mixins: [errorMixin, authenticationMixin, dateTimeMixin],
  props: {
    resortId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      resort: null,
      loading: true,
      flowLoading: false,
      flow: {},
      flows: [
        { id: "skidata.DefaultSkidataFlow", value: "Skidata TDI" },
        {
          id: "multi.DefaultSkidataSwisspassFlow",
          value: "Skidata TDI Swisspass",
        },
        { id: "axess.DefaultAxessFlow", value: "Axess DCI4WTP" },
        { id: "dss.DefaultDssFlow", value: "DSS MyData" },
        { id: "skidata.DefaultSkidataDazFlow", value: "Skidata DAZ" },
        { id: "multi.DefaultSkidataFeratelFlow", value: "Skidata TDI Feratel" },
        { id: "token.DefaultSkilineTokenFlow", value: "Skiline Token" },
        { id: "multi.DefaultSkidataAxessFlow", value: "Skidata Axess" },
        { id: "multi.DefaultAxessSwisspassFlow", value: "Axess Swisspass" },
        {
          id: "multi.DefaultSkidataOccAxessSwisspassFlow",
          value: "Skidata OCC Axess Swisspass",
        },
        { id: "baqueira.DefaultBaqueiraFlow", value: "Baqueira" },
        { id: "multi.DefaultAxessFeratelFlow", value: "Axess Feratel" },
        {
          id: "multi.DefaultSkidataFeratelSwisspassFlow",
          value: "Skidata Feratel Swisspass",
        },
      ],
    };
  },
  computed: {
    hasFlow() {
      return Object.keys(this.flow).length > 0;
    },
    timezones() {
      return this.dateTime_IANA_Timezones();
    },
    resortProvinces: {
      get() {
        if (this.resort.provinces) {
          return this.resort.provinces.join(",");
        }
        return "";
      },
      set(val) {
        this.resort.provinces = val
          .split(",")
          .map((x) => x.trim())
          .filter((x) => x.length > 0);
      },
    },
  },
  async created() {
    await this.getResort();
  },
  methods: {
    async getResort() {
      this.loading = true;
      await this.axios
        .get(`/Resort/GetResort?id=${this.resortId}`)
        .then((response) => {
          this.resort = response.data;
          this.getFlow();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateResort() {
      this.loading = true;
      this.axios
        .put(`/Resort/UpdateResort`, this.resort)
        .then((response) => {
          if (response && response.status == 200) {
            this.error_clear();
            this.$snotify.success("Successfully updated Resort!");
            this.upsertFlow();
            this.getResort();
          }
        })
        .finally(() => {
          this.loading = false;
          this.reloadResortCache();
        })
        .catch((error) => {
          this.$snotify.error("Error updating Resort!");
          this.error_clear();
          this.error_validate(error);
          this.loading = false;
        });
    },
    async reloadResortCache() {
      this.axios
        .post(`/Resort/ReloadResortCache`)
        .then(() => {})
        .catch(() => {
          this.$snotify.success(
            "Reload Resort Cache not successfull - changes are not yet applied to the system!"
          );
        });
    },
    async getFlow() {
      this.flowLoading = true;
      this.axios
        .get(`/Resort/GetFlow?id=${this.resort.id}`)
        .then((response) => {
          if (response.data) {
            this.flow = response.data;
          }
        })
        .finally(() => {
          this.flowLoading = false;
        });
    },
    async upsertFlow() {
      if (!this.flow.clazz) {
        return
      }
      this.flowLoading = true;
      const found = this.flows.find((x) => x.id == this.flow.clazz);
      this.flow.name = found.value;
      if (!this.flow.id) {
        this.flow.resortId = this.resort.id;
        this.axios
          .post(`/Resort/CreateFlow`, this.flow)
          .then((response) => {
            this.flow = response.data;
          })
          .finally(() => {
            this.flowLoading = false;
          });
      } else {
        this.axios.put(`/Resort/UpdateFlow`, this.flow).then(() => {
          this.flowLoading = false;
        });
      }
    },
  },
};
</script>

<style>
.tooltip.popover .popover-inner {
  background: white;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(white, 0.1);
  max-width: 1000px;
}

.popover-arrow {
  border-color: white;
}
.tooltip-arrow {
  z-index: 1;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
